import "./Platforms.css";

/* Row 1: 4 items  |  Row 2: 2 items (centered) — exactly as Figma shows */
const ROW1 = [
  { icon: "📱", label: "Mobile Games" },
  { icon: "🖥️", label: "PC Games" },
  { icon: "🎮", label: "PS Games" },
  { icon: "🌐", label: "AR/VR Games" },
];
const ROW2 = [
  { icon: "⚔️",  label: "Action Games" },
  { icon: "🎯",  label: "Vector Games" },
];

function PlatformCard({ icon, label, delay }) {
  return (
    <div className="platform-card reveal" style={{ transitionDelay: delay }}>
      <div className="platform-icon">{icon}</div>
      <p>{label}</p>
      <div className="platform-arrow">→</div>
    </div>
  );
}

export default function Platforms() {
  return (
    <section className="platforms-section section">
      <div className="container">
        {/* header */}
        <div className="reveal">
          <h2 className="section-title" style={{ textAlign: "center" }}>
            Game Development Expertise Across Platforms
          </h2>
          <p className="section-desc" style={{ margin: "12px auto 48px", textAlign: "center" }}>
            We build scalable, high-quality games tailored for multiple platforms and player experiences.
          </p>
        </div>

        {/* row 1 — 4 cards */}
        <div className="platforms-row platforms-row-4">
          {ROW1.map((p, i) => (
            <PlatformCard key={p.label} {...p} delay={`${i * 0.07}s`} />
          ))}
        </div>

        {/* row 2 — 2 cards centered */}
        <div className="platforms-row platforms-row-2">
          {ROW2.map((p, i) => (
            <PlatformCard key={p.label} {...p} delay={`${(i + 4) * 0.07}s`} />
          ))}
        </div>
      </div>
    </section>
  );
}
